import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import { navigateTo } from "../../../utils/navigation";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getOrganisationData = createAsyncThunk(
  "api/fetchData",
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/counsellor`,

        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      let status = "success";
      let data = {
        status: status,
        message: response.data,
      };
      return data; // Success: return data
    } catch (error) {
      // Handle error: rejectWithValue ensures proper error handling
      navigateTo("/");
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const organisationSlice = createSlice({
  name: "api",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganisationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrganisationData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOrganisationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default organisationSlice.reducer;
